export const SET_TEMPLATE_DATA = 'SET_TEMPLATE_DATA';
export const setTemplateDataAction = (data) => ({
    type: SET_TEMPLATE_DATA,
    payload: data
});
